export class Roles {
  static OPERATOR = ["Operator"];
  static ADMIN = ["Admin"];
  static HRAndADMIN = ["Hr", "Admin"]; // HR/Admin have company-wide access
  static HR = ["Hr"]; // HR/Admin have company-wide access
  static CHIEF = ["Chief", "Hr"]; // Chiefs have company-wide access
  static MANAGER = ["Manager", "Hr", "Chief"]; // Managers have team-level access
  static CLOCKING = ["Clocking", "Hr", "Chief", "Manager", "Admin"];
  static NOTADMIN = ["Clocking", "Hr", "Chief", "Manager"];
  static ANY = ["", "Clocking", "Hr", "Chief", "Manager", "Admin"];
}